export default "__VITE_ASSET__BLMceK94__"